import { SALES_EMAIL } from "./contact";

/**
 * What to show the user when a checkout is refused. A code with no sentence of its own falls
 * back to the backend's `detail`, which is written for a reader; `REQUEST_FAILED` does not,
 * because there its detail is the transport's own words ("Network Error").
 *
 * `BILLING_UNKNOWN_PACK` keeps its name for compatibility but now covers any item that is no
 * longer on sale: a pack, a product whose purchase went away, or an add-on sent on its own.
 */
export const checkoutMessage = (code: string, detail: string): string => {
  switch (code) {
    case "BILLING_UNKNOWN_PACK":
      return "This item is no longer available.";
    case "BILLING_INVALID_QUANTITY":
      return "Please enter a valid quantity.";
    case "CREDITS_WALLET_FROZEN":
      return `Your wallet is frozen. Please contact ${SALES_EMAIL}.`;
    case "CREDITS_NO_ACCOUNT":
      return `Your account is not set up for purchases yet. Please contact ${SALES_EMAIL}.`;
    case "BILLING_UNCONFIGURED":
    case "BILLING_UNAVAILABLE":
      return "Purchases are temporarily unavailable. Please try again later.";
    case "REQUEST_FAILED":
      return "Could not start checkout. Please check your connection and try again.";
    default:
      return detail;
  }
};
